export default __webpack_public_path__ + "2b0bf3ec3e7791b98d0dafa6c93d18b9.svg";